import axios, { AxiosError, AxiosRequestConfig, Method } from "axios";

export function getCurrentYear(): number {
    return new Date().getFullYear();
}

export function formatDateToIsoString(date: Date): string {
  return date.toISOString().split('T')[0];
}

export class ApiError extends Error {
    statusCode: number;
  
    constructor(message: string, statusCode: number) {
      super(message);
      this.statusCode = statusCode;
      Object.setPrototypeOf(this, ApiError.prototype);
    }
  }

export const apiSharedConfig: AxiosRequestConfig = {
    withCredentials: true,
  };
  
  
export async function apiRequest<T>(
    method: Method,
    url: string,
    data: any = null,
    config: AxiosRequestConfig = apiSharedConfig
    ): Promise<T> {
    try {
        const response = await axios({ method, url, data, ...config });
        return response.data;
    } catch (error) {
        const axiosError = error as AxiosError;
        const statusCode = axiosError.response!.status;
        const errorMessage: string = getErrorMessage(error);
        return Promise.reject(new ApiError(errorMessage, statusCode));
    }
}


export function getErrorMessage(error: any) :string {
    let errorMessage:string;
    if (error.code === 'ERR_NETWORK') {
        errorMessage = "could not connect to the server, check your internet connection."
    }
    else {
      errorMessage = error.response.data;
    }
    return errorMessage;
}

const amountFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  currencyDisplay: "symbol",
});


export function formatAmount(amount: number) :string {
  return amountFormatter.format(amount);
}

